<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-danger text-white">
      <h5 class="modal-title">
        Confirmation
      </h5>
    </header>
    <div class="modal-body">
      <h6>{{ messageTitle }}</h6>
      <b-form-checkbox
        v-if="options.checkbox"
        id="accepted-checkbox"
        v-model="checked"
        name="accepted-checkbox"
        value="true"
        unchecked-value="false"
      >
        <h6>{{ options.checkboxBody }}</h6>
      </b-form-checkbox>
    </div>
    <footer class="modal-footer">
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        Cancel</button
      ><button @click="handleConfirm" type="button" class="btn btn-danger">
        {{ options.removeButtonTitle ? options.removeButtonTitle : "Remove" }}
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogConfirmDelete",
  mixins: [DialogMixin],
  data() {
    return {
      checked: false
    };
  },
  methods: {
    handleConfirm() {
      this.proceed(this.checked); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped="">
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
